// extracted by mini-css-extract-plugin
export default {"disclaimer":"ResourceDischargePopover_disclaimer__5j7lB","inputField":"ResourceDischargePopover_inputField__zvJAI"};